import { ReusableNotesField } from './ReusableNotesField';
import { useUpdateImage } from 'pages/ListerVehicleUploadV2/hooks/useUpdateImage';
import { parsePath } from './utils';

type Props = {
  sectionId: string;
};

export const FinalReviewImageNotes = ({ sectionId }: Props) => {
  const [section, index] = parsePath(sectionId);
  const updateImage = useUpdateImage(section, index);

  const save = async (notes: string | null, fieldName = 'notes') => {
    updateImage({
      [fieldName]: notes
    });
  };

  return <ReusableNotesField autoFocus={false} save={save} sectionId={sectionId} />;
};
